import { createContext, useContext, useEffect } from 'react';

/**
 * Header 中央插槽：頁面可把自訂內容（如可編輯的文章標題）portal 進 header。
 * 用 DOM portal 而非 React state 傳遞，避免不穩定 reference 造成 render 迴圈。
 */
export interface HeaderSlotValue {
  slotEl: HTMLElement | null;
  setActive: (active: boolean) => void;
}

export const HeaderSlotContext = createContext<HeaderSlotValue>({
  slotEl: null,
  setActive: () => {},
});

/** 頁面呼叫：標記接管 header（隱藏預設標題），回傳插槽 DOM 供 createPortal 使用。 */
export function useHeaderSlot(): HTMLElement | null {
  const { slotEl, setActive } = useContext(HeaderSlotContext);
  useEffect(() => {
    setActive(true);
    return () => setActive(false);
  }, [setActive]);
  return slotEl;
}
